module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/high-capacity-transport-elite-reward-50.3fa81fb4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/high-capacity-transport-elite-reward-50.png
// module id = 3783
// module chunks = 11